import axios from 'axios'

const TransferService = {
  async get (params = {}) {
    return axios.get('scm/withdrawal/request-approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('scm/reports/withdrawal/approval-histories', { params })
  },

  async show (id) {
    return axios.get(`scm/withdrawal/request-approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('scm/withdrawal/request-approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`scm/withdrawal/request-approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`scm/withdrawal/request-approvals/${data.id}`, { data })
  }
}

export default TransferService
